import { Fragment } from "react";

import useSAAGroupMembers from "./UseSAAGroupMembers";

import SAAGroupsLoadingModal from "../components/dialogs/loading/SAAGroupsLoadingModal";

import SAAGroupMembersGrid from "../../../components/grids/saaGroupMembersGrid/SAAGroupMembersGrid";
import GroupMemberWorkflowModal from "../../../components/dialogs/groupMemberStatus/GroupMemberWorkflowModal";

import Headings from "@usas/ui-web/components/headings/Headings";

const SAAGroupMembers = () => {
  const {
    isGridLoading,
    gridData,
    state,
    onEditGroupMemberClicked,
    onEditGroupMemberStatusClicked,
    onCloseWorkflowPopup
  } = useSAAGroupMembers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Members</Headings.H3>
        </div>
      </div>
      <SAAGroupMembersGrid
        gridData={gridData}
        isLoading={isGridLoading}
        onEditClicked={onEditGroupMemberClicked}
        onEditStatusClicked={onEditGroupMemberStatusClicked} />
      {state.displayWorkflowPopup === true &&
        <GroupMemberWorkflowModal memberObj={state.workflowMemberObj} onCloseModal={onCloseWorkflowPopup} />
      }
      <SAAGroupsLoadingModal isLoading={false} />
    </Fragment>
  );
};

export default SAAGroupMembers;